export default __webpack_public_path__ + "static/media/room-11.1605f19e.jpg";